
import type {Dimensions} from "../Scene.tsx";

type BackingLightProps = {
    scene: Dimensions;
    intensity: number;
};

/**
 * BackingLight component - spotlights that illuminate from behind the scene
 */
export function BackingLight({scene, intensity}: BackingLightProps) {

    const {width, height, depth} = scene;

    const inside = 0.2;
    const deeper = 2.5;
    const topLeft: [number, number, number] = [-width/2+inside, height/2-inside, -depth-deeper];
    const topRight: [number, number, number] = [width/2-inside, height/2-inside, -depth-deeper];
    const bottomRight: [number, number, number] = [width/2-inside, -height/2+inside, -depth-deeper];
    const bottomLeft: [number, number, number] = [-width/2+inside, -height/2+inside, -depth-deeper];
    // const topCenter: [number, number, number] = [0, height/2-inside, -depth-deeper];
    // const rightCenter: [number, number, number] = [width/2-inside, 0, -depth-deeper];
    // const bottomCenter: [number, number, number] = [0, -height/2+inside, -depth-deeper];
    // const leftCenter: [number, number, number] = [-width/2+inside, 0, -depth-deeper];


    const angle=Math.PI/3;
    const decay = 0.5;

    // const i2 = 0.8;
    // const distance = 5;
    return (
        <>
            {/*<group position={topRight}>*/}
            {/*<object3D ref={targetRef} position={topRightTarget} />*/}
            <spotLight position={topLeft} angle={angle} intensity={intensity} decay={decay} />
            <spotLight position={topRight} angle={angle} intensity={intensity} decay={decay} />
            <spotLight position={bottomRight} angle={angle} intensity={intensity} decay={decay} />
            <spotLight position={bottomLeft} angle={angle} intensity={intensity} decay={decay} />

            {/*<pointLight position={topCenter} intensity={i2} distance={distance} decay={decay}/>*/}
            {/*<pointLight position={rightCenter} intensity={i2} distance={distance} decay={decay}/>*/}
            {/*<pointLight position={bottomCenter} intensity={i2} distance={distance} decay={decay}/>*/}
            {/*<pointLight position={leftCenter} intensity={i2} distance={distance} decay={decay}/>*/}

        </>
    );
}
